export const DATE_QUERY_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
